<template>
  <div>
    <!-- 我的消息 -->
    <div class="user-info5 w-100">
      <el-table :data="messageList" border stripe style="width: 100%">
        <el-table-column prop="content" label="留言内容" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.content || '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="留言类型" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 1 ? 'danger' : 'success'">{{
              scope.row.type === 1 ? '投诉' : '留言'
            }}</el-tag>
            <span style="margin-left: 10px" v-if="scope.row.type === 1"
              >投诉类型：{{ scope.row.sysDictData.value }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="whenCreated"
          label="留言时间"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.whenCreated || '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="whenCreated"
          label="回复"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.opinion || '无' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="no-content" style="display: flex; justify-content: center">
        <img src="../../../static/img/no_data5.png" />
      </div> -->
      <!-- <div class="top-box w-100">共<i>2条</i>消息</div>
			<div class="lower-box w-100">
				<ul>
					<li>
						<input type="checkbox" class="checkbox-style sonCheckbox" name="" id="" value="1" />
						<div class="info w-100">
							<span>2021-05-28 17:38:08</span><i>未读</i>
							<p>您的订单已发货，订单号为1651521223，请留意物流信息哟~</p>
						</div>
					</li>
					<li>
						<input type="checkbox" class="checkbox-style sonCheckbox" name="" id="" value="2" />
						<div class="info w-100">
							<span>2021-05-28 17:38:08</span><i class="active">已读</i>
							<p>您的订单已发货，订单号为1651521223，请留意物流信息哟~</p>
						</div>
					</li>
				</ul>
			</div> -->
    </div>
    <div class="user-info4 w-100 between-center" v-if="false">
      <div class="f-l between-center">
        <label class="checkbox-inline"
          ><input
            type="checkbox"
            class="checkbox-style allCheckbox"
            name=""
            id=""
            value=""
          />&nbsp;</label
        >
        <span onclick="checkboxItem()">删除所选</span>
        <span>设置为已读</span>
      </div>
      <div class="fanye gray">
        <div class="pull-right">
          <ul class="between-center">
            <li><a href="">&lt;</a></li>
            <li><a href="" class="active">1</a></li>
            <li><a href="">2</a></li>
            <li><a href="">3</a></li>
            <li><a href="">4</a></li>
            <li><a href="">5</a></li>
            <li><a href="">6</a></li>
            <li><a href="">&gt;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessage } from '../../common/http';

export default {
  data () {
    return {
      messageList: []
    }
  },
  mounted () {
    this.$emit('change_bread', 1);
    this.getMessageList();
  },
  methods: {
    getMessageList () {
      getMessage({
        type: '',
        pageSize: 1000
      }).then(res => {
        if (res.result) {
          this.messageList = res.data.rows;
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/meMsg.vue